import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed48cee"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "LikeShop"
}
const _hoisted_2 = { class: "LikeShop-header" }
const _hoisted_3 = { class: "LikeShop-list" }
const _hoisted_4 = { class: "LikeShop-page" }

import { onMounted, reactive } from 'vue'
import { t } from '@/plugins/i18n'
import { useRequest } from '@/util/useLoading'
import PaginationArrow from '@/components/common/PaginationArrow.vue'
import ShopItem from '@/components/common/ShopItem.vue'
import { getRecommendShopList } from '@/apis/shop'


export default /*#__PURE__*/_defineComponent({
  props: {
  // 来源渠道 null-我的频道 1-市场购 2-透明购(平台频道)
  channel: {
    type: String,
    default: null
  },
  // 平台分类 TB-淘宝 TM-天猫 AM-1688
  platformType: {
    type: String,
    default: null
  }
},
  setup(__props) {

const props = __props
onMounted(() => {
  getList()
})



const data: any = reactive({
  // 列表
  list: [],
  // 分页对象
  page: {
    currentPage: 1,
    pageSize: 10,
    total: 0,
    pages: 1
  }
})

// 分页切换
const pageChange = (page: number) => {
  data.page.currentPage = page
  getList()
}

// 获取列表
const [loading, getList] = useRequest(() => {
  const formData = {
    channel: props.channel,
    platformType: props.platformType,
    pageNum: data.page.currentPage,
    pageSize: data.page.pageSize
  }
  return getRecommendShopList(formData).then((res: any) => {
    if (res.code === '0') {
      data.list = res.data.records
      data.page.total = res.data.total
      data.page.pages = res.data.pages
    }
  })
})

// item不喜欢操作回调
const itemUnlike = (shopCode: string) => {
  const index = data.list.findIndex((item: any) => item.shopCode === shopCode)
  data.list.splice(index, 1)
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_unref(data).list.length !== 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('猜你喜欢的店铺')), 1),
        _withDirectives(_createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item) => {
            return (_openBlock(), _createBlock(ShopItem, {
              key: item.shopCode,
              item: item,
              onUnlike: itemUnlike
            }, null, 8, ["item"]))
          }), 128))
        ], 512), [
          [_directive_loading, _unref(loading)]
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(PaginationArrow, {
            currentPage: _unref(data).page.currentPage,
            pages: _unref(data).page.pages,
            "onUpdate:currentPage": pageChange
          }, null, 8, ["currentPage", "pages"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})